export default __webpack_public_path__ + "static/media/lamberet.40283b8a.png";